import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { UserMgtServiceService } from '../../services/user-mgt-service.service';
import { AppFilter } from '@app/shared/models';
import {
  SuiModal,
  ModalTemplate,
  TemplateModalConfig,
  SuiModalService,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';
import { ConfirmModal } from '@app/shared/modals';
import { UserActivityModal } from '../../modals/view-user-activity-modal/view-user-activity-modal.component';

@Component({
  selector: 'app-recently-logged-in-users',
  templateUrl: './recently-logged-in-users.component.html',
  styleUrls: ['./recently-logged-in-users.component.scss'],
})
export class RecentlyLoggedInUsersComponent implements OnInit {
  filter: AppFilter = new AppFilter();
  pending: boolean;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  users: Array<any> = [];
  success: any;
  totalItems: number;
  error: any;
  usersTwo = [
    {
      ipAddress: '168.201.11.90',
      hostName: '168.201.11.90',
      username: 'tolux0',
    },
    {
      ipAddress: '168.201.11.90',
      hostName: '168.201.11.90',
      username: 'sammyking',
    },
    {
      ipAddress: '168.201.11.90',
      hostName: '168.201.11.90',
      username: 'abuka08',
    },
  ];

  constructor(
    private location: Location,
    private userSvc: UserMgtServiceService,
    private modalService: SuiModalService
  ) {
    this.filter = new AppFilter({
      sidx: 'lastLoginDate',
      rows: 10,
      sord: 'desc',
    });
    this.getPage(1);
    this.totalItems = this.users.length;
  }
  searchFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'username',
        op: 'cn',
        data: '',
      },
    ],
  };
  headers = [
    {
      field: 'username',
      label: 'Username',
      type: 'text',
      op: 'cn',
      data: '',
    },
    {
      field: 'appUserEmail',
      label: 'Email Address',
      type: 'text',
      op: 'cn',
      data: '',
    },
    {
      field: 'lastCountry',
      label: 'Last Country',
      type: 'text',
      op: 'cn',
      data: '',
    },
    {
      field: 'lastAgent',
      label: 'Last Agent',
      type: 'text',
      op: 'cn',
      data: '',
    },
  ];
  headerFilters = [
    {
      field: 'status',
      label: 'status',
      type: 'select',
      op: 'eq',
      choices: [
        {
          optionId: 'INACTIVE',
          optionName: 'INACTIVE',
        },
        {
          optionId: 'ACTIVE',
          optionName: 'ACTIVE',
        },
      ],
      data: '',
    },
  ];
  cancelAd() {
    this.filter = new AppFilter({
      page: 1,
      rows: this.rows,
      _search: false,
    });

    this.getPage(1);
  }
  advancedSearch(e) {
    if (e) {
      this.filter._search = true;
      this.filter.filters = JSON.stringify(e);
    } else {
      this.filter.filters = {};
      this.filter._search = false;
    }
    this.filter.page = 1;

    this.getPage(1);
  }
  getPage(page) {
    this.filter.page = page;
    this.pending = true;
    this.userSvc
      .getRecentlyLoggedInUsers({
        params: this.filter,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.totalItems = +res.records;
          this.users = res.rows;
          this.currentPage = +res.page;
          this.rows = this.filter.rows;
        },
        (error) => {
          this.pending = false;
          this.error = error.error ? error.error : error;
        }
      );
  }

  blacklistIpAddress(user) {
    this.pending = true;
    this.userSvc
      .blacklist({ appUserId: user.user.appUserId, reason: 'Yes' })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'Address BlackListed Successfully';
          setTimeout(() => {
            this.getPage(1);
          }, 1200);
        },
        (error) => {
          this.pending = false;
          this.error = error.error ? error.error : error;
        }
      );
  }
  viewUser(user) {
    this.modalService
      .open(new UserActivityModal('See User Activity', user, ModalSize.Tiny))
      .onApprove((payload) => {
        // this.addWorkflowGroup(payload);
      })
      .onDeny(() => {});
  }
  blacklistIp(user) {
    this.modalService
      .open(
        new ConfirmModal(
          'Blacklist',
          'Are you sure you want to blacklist this User',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.blacklistIpAddress(user);
      })
      .onDeny(() => {});
  }
  ngOnInit(): void {}

  goBack() {
    this.location.back();
  }
  searchRecords(search) {
    let searchFilter = {
      groupOp: 'AND',
      rules: [
        {
          field: 'username',
          op: 'cn',
          data: '',
        },
      ],
    };
    searchFilter.rules[0].data = search;
    this.filter.filters = JSON.stringify(searchFilter);
    this.getPage(1);
  }

  sortRecords(search) {
    this.filter.sord = search;
    this.filter.sidx = 'desc';
    this.getPage(1);
  }

  //handles rows display
  displayRecords(row) {
    this.filter['rows'] = row;
    this.getPage(1);
  }

  nextPage(page: number) {
    //get and assign current page
    this.currentPage = page;
    this.getPage(this.currentPage);
  }
}
